import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { BillToModel, CartLineModel, CartModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";

const push = ga.push;

// declare global {
//     interface Window {
//         dataLayer: [{}];
//     }
// }

const windowExist = typeof window !== "undefined";
const productIndex = 3;

// export const push = (data: object) => {
//     if (windowExist && Object.prototype.hasOwnProperty.call(window, "dataLayer")) {
//         window.dataLayer.push(data);
//     }
// };

export const resolveCategory = () => {
    if (windowExist) {
        const resolvedCategory = window.location.pathname
            .slice(1)
            .replace(/-/gu, " ")
            .split("/")
            .filter((category, i) => i !== 0);
        if (resolvedCategory.length === productIndex) {
            resolvedCategory.pop();
        }
        return resolvedCategory.join("/");
    }
};

export const resolveVariant = (title: any) => title.replace(/[sS]*.*( - )/, "");

const formatPrice = (price: number) => price?.toFixed(2) ?? "";

const mapCartLines = (cart: any): Array<object> =>
    cart.cartLines?.map((cartLine: CartLineModel) => {
        const price = cartLine.pricing?.unitNetPrice.toFixed(2);
        return {
            name: cartLine.shortDescription,
            id: cartLine.erpNumber,
            ...(price ? { price } : {}),
            quantity: cartLine.qtyOrdered,
            variant: resolveVariant(cartLine.shortDescription),
        };
    });

const mapCartLine = (product: ProductModel, productInfo: ProductInfo): object => {
    const priceModel = productInfo.pricing?.unitNetPrice ?? 0;
    const brand = product.brand ?? "";
    return {
        name: product.productTitle,
        id: product.productNumber,
        brand,
        price: formatPrice(priceModel),
        quantity: productInfo.qtyOrdered,
        category: resolveCategory(),
    };
};

const mapProductImpression = (products: ProductModel[] | undefined, pageType: string) =>
    products?.map((product, position) => ({
        name: product.productTitle,
        id: product.productNumber,
        price: formatPrice(product.unitListPrice),
        category: resolveCategory(),
        list: pageType,
        position: position + 1,
    }));

export const dispatchProductClickEvent = (productContext: ProductContextModel) => {
    const { product, productInfo } = productContext;
    push({
        event: "productClick",
        ecommerce: {
            click: {
                actionField: {
                    list: "Catalog Page",
                },
                products: [mapCartLine(product, productInfo)],
            },
        },
    });
};

export const dispatchCheckoutEvent = (stepNumber: number, optionType: string, cart: CartModel) => {
    push({
        event: "checkout",
        ecommerce: {
            checkout: {
                actionField: { step: stepNumber, option: optionType },
                products: mapCartLines(cart) ?? [],
            },
        },
    });
};

export const dispatchAddToCartEvent = (productContext: ProductContextModel, currency: string | undefined) => {
    const { product, productInfo } = productContext;
    push({
        event: "addToCart",
        ecommerce: {
            currencyCode: currency,
            add: {
                products: [mapCartLine(product, productInfo)],
            },
        },
    });
};

export const dispatchPurchaseEvent = (cart: CartModel, erpNumber?: string, billTo?: BillToModel) => {
    push({
        event: "purchase",
        ecommerce: {
            purchase: {
                actionField: {
                    id: erpNumber,
                    affiliation: billTo?.customerName ?? "Online Store",
                    revenue: formatPrice(cart.orderSubTotal),
                    tax: formatPrice(cart.totalTax),
                    shipping: formatPrice(cart.shippingAndHandling),
                },
                products: mapCartLines(cart) ?? [],
            },
        },
    });
};

export const dispatchProductImpressions = (
    products: ProductModel[] | undefined,
    currency: string | undefined,
    pageType: string,
) => {
    if (products?.length === 0) {
        return;
    }

    push({
        event: "productImpression",
        ecommerce: {
            currencyCode: currency,
            impressions: mapProductImpression(products, pageType),
        },
    });
};
